"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areaLabelPositionCalculation = exports.angleLabelPositionCalculation = exports.heightLabelPositionCalculation = exports.distanceLabelPositionCalculation = exports.selectLabel = void 0;
const three_1 = require("three");
const CSS2DRenderer_1 = require("three/examples/jsm/renderers/CSS2DRenderer");
const UiElements_1 = require("../../ui/UiElements");
const color_1 = require("./color");
function selectLabel(measureType, point, lineId) {
    const color = (0, color_1.selectColor)(measureType);
    const hexStringColor = colorToHexString(new three_1.Color(color));
    const div = createLabel(hexStringColor);
    const lineLabel = new CSS2DRenderer_1.CSS2DObject(div.domEl);
    lineLabel.position.copy(point);
    lineLabel.name = "lineLabel_" + lineId;
    lineLabel.renderOrder = Infinity;
    return lineLabel;
}
exports.selectLabel = selectLabel;
function distanceLabelPositionCalculation(positions, pointIdx) {
    let idx = pointIdx;
    const start = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const end = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    return new three_1.Vector3().lerpVectors(start, end, 0.5);
}
exports.distanceLabelPositionCalculation = distanceLabelPositionCalculation;
function heightLabelPositionCalculation(positions) {
    const start = new three_1.Vector3(positions[3], positions[4], positions[5]);
    const end = new three_1.Vector3(positions[6], positions[7], positions[8]);
    return new three_1.Vector3().lerpVectors(start, end, 0.5);
}
exports.heightLabelPositionCalculation = heightLabelPositionCalculation;
function angleLabelPositionCalculation(positions) {
    let idx = 0;
    const start = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const corner = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const end = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    let dir = end.clone().sub(start);
    dir.multiplyScalar(0.5);
    dir = start.clone().add(dir).sub(corner).normalize();
    let dist = Math.min(corner.distanceTo(start), corner.distanceTo(end));
    dist = dist / 9;
    return corner.clone().add(dir.multiplyScalar(dist));
}
exports.angleLabelPositionCalculation = angleLabelPositionCalculation;
function areaLabelPositionCalculation(positions, pointIdx) {
    const areaCenter = new three_1.Vector3();
    const size = (pointIdx + 3);
    for (let index = 0; index < size;) {
        areaCenter.add(new three_1.Vector3(positions[index++], positions[index++], positions[index++]));
    }
    return areaCenter.divideScalar(size / 3);
}
exports.areaLabelPositionCalculation = areaLabelPositionCalculation;
function createLabel(color) {
    return new UiElements_1.DivEl()
        .setClass('measurement-label')
        .setStyle({ 'background-color': color })
        .setInnerHTML('0');
}
function colorToHexString(color) {
    return '#' + color.getHexString();
}
